import React, { createContext, useReducer } from 'react';

/**
 * 建立 Context
 */
export const EarthquakeContext = createContext({
    state: { earthquakes: [] },
    dispatch: () => { console.warn('未初始化 EarthquakeContext Provider'); },
});

/**
 * 初始狀態
 */
const initialState = {
    earthquakes: [] // 存放地震資料
};

/**
 * Reducer 處理邏輯
 */
function earthquakeReducer(state, action) {
    switch (action.type) {
        case 'INITIAL_EARTHQUAKES':
            // 確保 payload 是數組且有值
            const earthquakeData = Array.isArray(action.payload) ? action.payload : [];
            return {
                ...state,
                earthquakes: earthquakeData.sort((a, b) => new Date(b.OriginTime) - new Date(a.OriginTime))
            };

        case 'UPDATE_EARTHQUAKES':
            // console.log('更新地震資料:', action.payload);

            // 建立一個 Map 來存放新的地震資料，避免重複
            const updatedEarthquakeMap = new Map();

            // 先放入舊的資料
            state.earthquakes.forEach(eq => updatedEarthquakeMap.set(eq._id, eq));

            // 遍歷新的地震資料，更新舊的或新增
            action.payload.forEach(newEq => {
                const existingEq = updatedEarthquakeMap.get(newEq._id);

                if (!existingEq || new Date(existingEq.updatedAt) < new Date(newEq.updatedAt)) {
                    // 如果沒有這筆地震，或 updatedAt 更新了，就更新 Map
                    updatedEarthquakeMap.set(newEq._id, newEq);
                }
            });

            // 轉回陣列，並按照 OriginTime 排序（新的在前）
            const updatedEarthquakes = Array.from(updatedEarthquakeMap.values()).sort(
                (a, b) => new Date(b.OriginTime) - new Date(a.OriginTime)
            );

            return {
                ...state,
                earthquakes: updatedEarthquakes
            };

        case 'MORE_EARTHQUAKES': {
            const existingMap = new Map();

            // 先把 state 裡的 earthquakes 做成 Map (舊的)
            state.earthquakes.forEach(item => {
                existingMap.set(item._id, item);
            });

            // 遍歷 payload，將新資料與舊資料合併
            action.payload.forEach(item => {
                const oldData = existingMap.get(item._id);
                if (!oldData) {
                    // 這是新的地震事件，直接加入
                    existingMap.set(item._id, item);
                } else {
                    // 舊的 already exists，更新它（用 `updatedAt` 比較）
                    if (new Date(oldData.updatedAt) < new Date(item.updatedAt)) {
                        existingMap.set(item._id, item);
                    }
                }
            });

            const updatedEarthquakes = Array.from(existingMap.values()).sort(
                (a, b) => new Date(b.OriginTime) - new Date(a.OriginTime)
            );

            return {
                ...state,
                earthquakes: updatedEarthquakes, // 確保地震資料按照 OriginTime 排序
            };
        }

        default:
            return state;
    }
}

/**
 * Provider 負責提供 earthquake 資料
 */
export const EarthquakeProvider = ({ children }) => {
    const [state, dispatch] = useReducer(earthquakeReducer, initialState);

    return (
        <EarthquakeContext.Provider value={{ state, dispatch }}>
            {children}
        </EarthquakeContext.Provider>
    );
};

export default EarthquakeProvider;
